import { createSlice } from "@reduxjs/toolkit";

const walletSlice = createSlice({
  name: "userwallet",
  initialState: {
    info: null, // Default value
  },
  reducers: {
    setLivewallet: (state, action) => {
      state.info = action.payload;
    },
   
  },
});

export const { setLivewallet } = walletSlice.actions;
export default walletSlice.reducer;